module.exports = __webpack_public_path__ + "img/sample.09b8653f.png";